import { useEffect } from "react";
import { connect } from "react-redux";
import { useRouter } from "next/router";
import { processFeatures } from "../basic/appsIncluded/components/features/helpers/featuresProcessing";
import { handleFeaturesSwitch } from "../basic/appsIncluded/components/features/helpers/featuresActions";
import { updateBodyStack, updateFeaturesData } from "../../../redux/actions/DeploymentActions";
import { immutableArraySlice } from "../../../helpers/common";

function FeatureInit({
                         currentApp, subscriptions, plan, dispatch,
                         // custom apps
                         custom, featuresDataCustom,
                         bodyStack
                     }) {

    const router = useRouter();

    useEffect(() => {

        const {features, dependencies} = processFeatures(
            custom ? {features: featuresDataCustom} : currentApp,
            subscriptions,
            custom
        );

        if (!router.query.id && !custom) {
            const suggestedFeatures = features.filter(feature => {
                return (
                    !!feature.suggested
                    && !feature.form?.some(el => el.type === 'field' && !!el.required) // if form is provided, required fields should be submitted first to enable feature
                    && plan['includes'].some(i => ( // supported by plan
                        i.code === feature.type // features
                        || i.code === feature.code // subscriptions
                        || i.code === feature.category?.[0]?.name // features
                    ))
                )
            });
            if (!!suggestedFeatures?.length) {
                let newForm = [];
                // enable predefined values from app form
                suggestedFeatures.map(f => {
                    let appForm = {code: f.code};
                    f.form?.map(el => {
                        if (el.type === 'radio' && !!el.defaultValue && !!el.name) appForm[el.name] = el.defaultValue;
                    })
                    if (Object.keys(appForm).length > 1) newForm.push(appForm)
                })

                dispatch(updateBodyStack({form_app: newForm}));
                handleFeaturesSwitch(suggestedFeatures, custom);
            }
        }

        dispatch(updateFeaturesData({features, dependencies}));
    }, []);

    return null
}

const mapStateToProps = state => ({
    // subscriptions: state.commonData.subscriptions,
    currentApp: state.deployment.currentApp,
    bodyStack: state.deployment.bodyStack,
    features: state.deployment.featuresData.features,
    plan: state.userData?.user?.plan || {},
});

export default connect(mapStateToProps)(FeatureInit)